import React from 'react'
import Heading, { HeadingProps } from './Heading'
import List from './List'
import { FooterColumnLinkProps } from './FooterColumnLink'
import clsx from 'clsx'
import styles from './styles.module.scss'

export type ColumnProps = {
  items: FooterColumnLinkProps[],
  type: string
} & HeadingProps

const Column = ({ heading, items, type }: ColumnProps) => {
  const columnClass = clsx(
    styles.column,
    type === 'social' && styles.isSocial
  )

  return (
    <div className={columnClass}>
      <Heading heading={heading} />
      <List items={items} type={type} />
    </div>
  )
}

export default React.memo(Column)
